import { Component } from '@angular/core';
import { IsEmptyDirective } from '@shared/directives/is-empty/is-empty.directive';

/**
 * CardComponent represents a customizable card container with optional features.
 */
@Component({
  selector: 'app-card',
  imports: [
    IsEmptyDirective,
  ],
  templateUrl: './card.component.html',
  styleUrl: './card.component.css'
})
export class CardComponent {
}
